import React from 'react';
import { useLocation, Link } from 'react-router-dom'; 
import './Footer.css';
import logo from '../../assets/Logo/vps infrastructure logo.png';

const Footer = () => {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';

  const centers = [
    { city: "Dindigul", icon: "bi-house-heart" },
    { city: "Vedasandur", icon: "bi-geo-alt" },
    { city: "Oddanchatram", icon: "bi-buildings" },
    { city: "Madurai", icon: "bi-house-heart" },
    { city: "Karur", icon: "bi-buildings" },
    { city: "Coimbatore", icon: "bi-house-heart" },
    { city: "Chennai", icon: "bi-geo-alt" },
    
  ];

  return (
    <footer className="footer-wrapper">
      <div className="news-container">
        <div className="newsletter-banner shadow-lg">
          <div className="row align-items-center g-0">
            <div className="col-lg-4 d-none d-lg-flex justify-content-center newsletter-img-box">
              <div 
                style={{
                  position: 'relative',
                  width: '300px',
                  height: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  border: '30px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div 
                  className="floating-3d-element"
                  style={{
                    width: '85%',
                    height: '85%',
                    backgroundColor: '#ffffff',
                    border: '10px solid #002147',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden'
                  }}
                >
                  <img src={logo} alt="VPS Logo" style={{ width: '70%', height: '70%', objectFit: 'contain' }} />
                </div>
              </div>
            </div>
            
            <div className="col-lg-8">
              {isContactPage ? (
                <div className="map-container-wrapper p-0 overflow-hidden" style={{ minHeight: '350px' }}>
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3924.234567890!2d77.9745!3d10.3624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTDCsDIxJzQ0LjYiTiA3N8KwNTgnMjguMiJF!5e0!3m2!1sen!2sin!4v1234567890" 
                    width="100%" 
                    height="100%" 
                    style={{ border: 0, minHeight: '350px', display: 'block' }} 
                    allowFullScreen="" 
                    loading="lazy"
                    title="Google Map Location"
                  ></iframe>
                </div>
              ) : (
                <div className="p-4 p-md-5">
                  <h2 className="newsletter-headline mb-4">Visit Our Experience Centers Across Tamil Nadu</h2>
                  <div className="footer-locations-grid">
                    {centers.map((c, i) => (
                      <div key={i} className="location-pill">
                        <i className={`bi ${c.icon}`}></i>
                        <span>{c.city}</span>
                      </div>
                    ))}
                  </div>
                  <p className="privacy-note mt-4">
                    Explore our modern design aesthetics. <Link to="/contact" className='contact-us'>Contact Us</Link>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="footer-card shadow-sm">
          <div className="row g-4 p-5">
            <div className="col-lg-4 col-md-12">
              <div className="footer-brand d-flex align-items-center gap-2 mb-3">
                <img src={logo} alt="VPS Logo" className="footer-logo-img" />
                <h3 className="mb-0">VPS <span>INFRASTRUCTURE</span></h3>
              </div>
              
              <p className="footer-text mb-2">
                <i className="bi bi-geo-alt-fill text-warning me-2"></i>
                26/B6,Indra Nagar,Vedasandur Dindigul – 624710.
              </p>
              
              <div className="footer-socials d-flex gap-3 mt-3">
                  {/* External WhatsApp Link using a standard anchor tag */}
                  <a 
                    href="https://wa.me/message/NSSSDLWZXOALP1" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    aria-label="Whatsapp"
                  >
                    <i className="bi bi-whatsapp"></i>
                  </a>

                  {/* Other socials changed to standard <a> tags assuming they go to real external profiles */}
                  <a href="https://x.com/your-username" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <i className="bi bi-twitter-x"></i>
                  </a>
                  <a href="https://www.instagram.com/invites/contact/?igsh=57ge5pmfwk4r&utm_content=fgl2av5" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="https://www.facebook.com/share/1EBCjiBRHK/" target="_blank" 
                    rel="noopener noreferrer" 
                    aria-label="Facebook"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>
                </div>
            </div>

            <div className="col-lg-2 col-md-4 col-6 ms-auto">
              <h6 className="footer-title">Company</h6>
              <ul className="list-unstyled footer-links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-4 col-6">
              <h6 className="footer-title">Industries</h6>
              <ul className="list-unstyled footer-links">
                <li><Link >Residential</Link></li>
                <li><Link >Commercial</Link></li>
                <li><Link >Industrial</Link></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-4">
              <h6 className="footer-title">Services</h6>
              <ul className="list-unstyled footer-links">
                <li><Link >General Contracting</Link></li>
                <li><Link >Design & Build</Link></li>
                <li><Link >Renovation</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom border-top p-4 d-flex justify-content-between align-items-center flex-wrap">
            <p className="mb-0">© 2026 VPS INFRASTRUCTURE. All rights reserved.</p>
            <div className="footer-legal d-flex gap-4">
              <Link to="/review">Review</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;